import { Link } from "react-router-dom";
import Logo from "assets/svg/logo.svg";
import { FaXTwitter, FaFacebook, FaLinkedinIn, FaInstagram } from "react-icons/fa6";
import { useModal } from "context/modal-context";

const Footer = () => {
  const { openModal } = useModal();

  return (
    <div className="w-full bg-[#0E1421]">
      {/* Main footer content */}
      <div className="flex flex-col items-start w-full gap-12 px-8 py-16 xl:px-20 xl:flex-row xl:gap-6 xl:justify-between">
        {/* Logo */}
        <div className="w-full xl:w-[180px] flex flex-col items-start gap-2">
          <Link to="/">
            <img
              src={Logo}
              alt="logo"
              className="object-contain w-[120px] h-[64px] lg:w-[150px] lg:h-[80px]"
            />
          </Link>

        </div>

        {/* Our Services */}
        <div className="w-full xl:w-[200px] flex flex-col gap-4">
          <p className="font-semibold text-yellow-200">Our Services</p>
          <button onClick={() => openModal("hire-talent")} className="text-left transition-colors text-grey-200 hover:text-white">
            Hire a Talent
          </button>
          <button onClick={() => openModal("start-project")} className="text-left transition-colors text-grey-200 hover:text-white">
            Web and Software Development / Project Delivery
          </button>
          <button onClick={() => openModal("managed-service")} className="text-left transition-colors text-grey-200 hover:text-white">
            Managed Technology Services
          </button>
          <button onClick={() => openModal("corporate-training")} className="text-left transition-colors text-grey-200 hover:text-white">
            Corporate and Bespoke Training
          </button>
        </div>

        {/* Academy & Product */}
        <div className="w-full xl:w-[180px] flex flex-col gap-8">
          <div className="flex flex-col gap-4">
            <p className="font-semibold text-yellow-200">Academy</p>
            <a href="https://stacstart.com/" target="_blank" rel="noopener noreferrer" className="transition-colors text-grey-200 hover:text-white">
              Stacstart
            </a>
            <a href="https://conclaseacademy.us" target="_blank" rel="noopener noreferrer" className="transition-colors text-grey-200 hover:text-white">
              Stacstart US
            </a>
          </div>

          <div className="flex flex-col gap-4">
            <p className="font-semibold text-yellow-200">Product</p>
            <div className="flex items-center gap-3">
              <a href="https://stacstart.com/jobs" target="_blank" rel="noopener noreferrer" className="transition-colors text-grey-200 hover:text-white">
                Stacstarts Job
              </a>
              <span className="bg-yellow-100 text-blue-100 text-xs font-semibold px-2 py-0.5 rounded">
                Hiring
              </span>
            </div>
          </div>
        </div>

        {/* Contact us */}
        <div className="w-full xl:w-[260px] flex flex-col gap-5">
          <p className="font-semibold text-yellow-200">Contact us</p>

          <div className="flex flex-col gap-1">
            <p className="font-semibold text-yellow-200">Nigeria 🇳🇬</p>
            <p className="text-sm leading-relaxed text-grey-200">
              No 10, Wole Ogunjimi Street, Opebi, Ikeja, Lagos.
            </p>
          </div>

          <div className="flex flex-col gap-1">
            <p className="font-semibold text-yellow-200">United State 🇺🇸</p>
            <p className="text-sm leading-relaxed text-grey-200">
              1234 Innovation Drive Denver, Colorado 80202 United States
            </p>
          </div>

          <p className="text-sm text-grey-200">+2347052854847</p>
          <p className="text-sm text-grey-200">+1 (720) 555-0123</p>
          <a
            href="mailto:info@Conclaseint.com"
            className="text-sm underline transition-colors text-grey-200 hover:text-white"
          >
            info@Conclaseint.com
          </a>
        </div>
      </div>

      {/* Bottom bar */}
      <div className="w-full border-t border-[rgba(255,255,255,0.1)] px-8 xl:px-20 py-6 flex flex-col sm:flex-row items-center justify-between gap-4">
        <p className="text-sm text-grey-200">
          © 2026. All rights reserved by Conclaseint
        </p>

        {/* Social icons */}
        <div className="flex items-center gap-3">
          <a
            href="https://x.com/conclasehq"
            target="_blank"
            rel="noreferrer"
            className="w-10 h-10 rounded-full border border-[rgba(255,255,255,0.3)] flex items-center justify-center hover:border-white transition-colors text-white"
          >
            <FaXTwitter size={16} />
          </a>

          <a
            href="https://www.facebook.com/share/1D1GwGv1KQ/?mibextid=wwXIfr"
            target="_blank"
            rel="noreferrer"
            className="w-10 h-10 rounded-full border border-[rgba(255,255,255,0.3)] flex items-center justify-center hover:border-white transition-colors text-white"
          >
            <FaFacebook size={16} />
          </a>

          <a
            href="https://www.linkedin.com/company/conclasehq/"
            target="_blank"
            rel="noreferrer"
            className="w-10 h-10 rounded-full border border-[rgba(255,255,255,0.3)] flex items-center justify-center hover:border-white transition-colors text-white"
          >
            <FaLinkedinIn size={16} />
          </a>

          <a
            href="https://www.instagram.com/conclasehq?igsi=OG92amZqZDhtYXln"
            target="_blank"
            rel="noreferrer"
            className="w-10 h-10 rounded-full border border-[rgba(255,255,255,0.3)] flex items-center justify-center hover:border-white transition-colors text-white"
          >
            <FaInstagram size={16} />
          </a>
        </div>
      </div>
    </div>
  );
};

export default Footer;
